import React, { FC } from 'react';
import { useLocale } from '../../../../contexts/localeContext';
import { TranslationKeys } from '../../../../contexts/TranslationKeys';

interface SummaryProps {
    onBack: (e) => void;
    selectedBiometricDevices: string[];
}

const Summary: FC<SummaryProps> = ({ onBack, selectedBiometricDevices }) => {
    const { translate } = useLocale();

    return <div className="pt-3 pr-3 h-full relative">
        <h2 className="text-lg font-bold">{translate.byKey(TranslationKeys.selectedDevices)}</h2>
        <div className="flex flex-row p-1 ">
            <ul className='text-xs text-black list-disc list-inside dark:text-gray-400'>
                {selectedBiometricDevices.map((item) => (
                    <li>
                        {item['baseDeviceName'] + ' (' + item['address'] + ')'}
                    </li>
                ))}
            </ul>
        </div>
        <div className="flex justify-end w-full absolute bottom-0 pr-3 pb-3 ">
            <button
                className={`py-1 px-5 mt-3 mr-2 text-portal-blue-primary-shade2`}
                type="button"
                onClick={(e) => onBack(e)}>{translate.byKey(TranslationKeys.back)}</button>
            <button
                className={`py-1 px-5 mt-3 bg-lime rounded-full text-white`}
                type="submit">{translate.byKey(TranslationKeys.install)}</button>
        </div>
    </div>
}

export default Summary;
